import { useCallback, useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { DateInput3 } from "../../components/_input/_dateInput_3";
import DatePicker from 'react-datepicker';
import moment from "moment";
import config from '../../configuration/config';
import Skeleton from 'react-loading-skeleton'
import Popup from "../../User/popup";
import Joi from "joi";
import axios from "axios";
import 'moment/locale/ar';
import { GetMessages, formValidate } from '../../utils/validation';
import 'moment/locale/en-gb'; // الإنجليزية البريطانية (اختياري)
export function DeliveryScheduling() {
    const history = useHistory();
    const location = useLocation();
    const { sn, vehicleUser } = useParams();
    const { t: trans, i18n } = useTranslation(["new", "employment", "cartFile"]);
    const query = new URLSearchParams(location.search);
    const salesOrderId = query.get('Salesorderid');
    const hasServices = query.get('hasServices');
    let lang = (i18n.language || 'ar');
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [loding, setLoding] = useState(false);
    const [VINDetails, setVINDetails] = useState(null);
    const [VehicleDeliveryScheduling, setVehicleDeliveryScheduling] = useState(null);
    const [brand, setBrand] = useState(null);
    const [listTimeAvailable, setListTimeAvailable] = useState([]);
    const [listTimeAvailableScheduling, setListTimeAvailableScheduling] = useState([]);
    const [listTimeAllScheduling, setListTimeAllScheduling] = useState([]);
    const [requestForm, setRequestForm] = useState({
        date: '',
        time: '',

    });
    const Schema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages())
    });
    useEffect(() => {


        if (sn) {
            GetVINDetails(sn);
            GetVehicleDeliveryScheduling();
        }




    }, [sn])

    async function GetVINDetails(VIN) {



        const Body = {
            "VIN": VIN,
            "UserId": vehicleUser
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/App_GetVINDetailsByUserId`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                ////console.log("App_GetVINDetails:", response.data);
                const INDetails = response.data[0];
                setVINDetails(INDetails);
                setBrand(INDetails?.BrandID);
            })
            .catch(function (error) {

                //console.log(error);
                setVINDetails([]);

            });


    }
    async function GetVehicleDeliveryScheduling() {

        const Body = {
            "SN": sn,
            "GuestID": vehicleUser,
            "SalesOrderID": salesOrderId,
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_GetVehicleDeliveryScheduling`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log("Site_GetVehicleDeliveryScheduling:", response.data);
                const Schedulin = response.data[0];
                setVehicleDeliveryScheduling(Schedulin);

                if (Schedulin?.IsDelivered != true) {

                    getAvailableDeliverySlots(Schedulin);
                    GetAvailableVehicleDeliveryScheduling(moment(Date()).format('yyyy-MM-DD'),
                        Schedulin?.SiteID);
                }


                if (Schedulin?.BookingTo || Schedulin?.IsDelivered == true) {

                    setShowFinalPopup(true);
                }

            })
            .catch(function (error) {


            });


    }
    async function GetAvailableVehicleDeliveryScheduling(SelectedDate, SiteID = VehicleDeliveryScheduling?.SiteID) {

        const StandardDeliveryDuration = (hasServices == true || hasServices == "true" || hasServices == 1) ? false : true;
        const Body = {
            "SelectedDate": SelectedDate,
            "SiteID": SiteID,
            "StandardDeliveryDuration": StandardDeliveryDuration,
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_GetAvailableVehicleDeliveryScheduling`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                const Schedulin = response.data;
                setListTimeAvailableScheduling(Schedulin);


                const lt = Schedulin?.map(x => x.FromTime)
                // console.log("lt:", lt);
                setListTimeAvailable(lt);
            })
            .catch(function (error) {


            });


    }
    function getAvailableDeliverySlots(settings) {
        const start = new Date(settings.DeliveryStartTime);
        const end = new Date(settings.DeliveryEndTime);
        console.log("getAvailableDeliverySlots:", settings);

        // تأكد من أن التواريخ صالحة
        if (isNaN(start) || isNaN(end)) {
            console.error("تواريخ غير صالحة:", settings.DeliveryStartTime, settings.DeliveryEndTime);
            return [];
        }

        // احسب المدة بالاعتماد على hasServices
        var duration = (hasServices == true || hasServices == "true" || hasServices == 1)
            ? settings.ExtendedDeliveryDuration
            : settings.StandardDeliveryDuration;

        if (!duration || duration <= 0) {
            console.warn("مدة التوصيل غير صالحة:", duration);
            duration = 15;
        }

        const slots = [];
        let current = new Date(start);

        while (current.getTime() + duration * 60000 <= end.getTime()) {
            const slotStart = new Date(current);
            const slotEnd = new Date(current.getTime() + duration * 60000);

            slots.push({
                FromTime: formatTime(slotStart),
                ToTime: formatTime(slotEnd),
            });

            current = new Date(current.getTime() + duration * 60000);
        }

        const result = slots.slice(0, settings.MaxBookingsPerDay);
        setListTimeAllScheduling(result);
        console.log("result:", result);
        return result;
    }

    function formatTime(date) {
        try {
            if (!(date instanceof Date) || isNaN(date)) return "00:00:00";

            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `${hours}:${minutes}:00`;
        } catch (e) {
            console.error("Invalid date in formatTime:", e);
            return "00:00:00";
        }
    }

    const [error, setError] = useState({});
    const submitRequest = async () => {

        setError(null);
        const result = formValidate(Schema, requestForm) ?? {};
        setError(result);
        if (Object.keys(result).length == 0 && loding == false) {

            setLoding(true);
            if (moment(requestForm?.date, "YYYY-MM-DD", true).isValid() && moment(requestForm?.time, "HH:mm", true).isValid()) {

                const timeFromCheck = moment(requestForm?.time).format('HH:mm:ss');
                const dateCheck = moment(requestForm?.date).format('YYYY-MM-DD');

                console.log("listTimeAvailableScheduling:", listTimeAvailableScheduling);
                console.log("requestForm?.time:", requestForm?.time);
                const toTime = listTimeAvailableScheduling?.find(x => x.FromTime?.includes(timeFromCheck))?.ToTime;

                console.log("toTime:", toTime);
                const BookingTo = moment(`${dateCheck} ${toTime}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss');



                const BookingFrom = moment(`${dateCheck} ${timeFromCheck}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss');

                console.log("BookingFrom:", BookingFrom);
                console.log("BookingTo:", BookingTo);
                try {

                    const response = await axios.put(

                        `${config.controllURL}${i18n.language || 'ar'}/api/Pages/UpdateVehicleDeliveryScheduling`,
                        {
                            // "WindowName": "VehicleDeliveryScheduling",
                            "Values": {
                                "BookingFrom": BookingFrom,
                                "BookingTo": BookingTo

                            },
                            "Filters": `Where  GUID = '${VehicleDeliveryScheduling?.GUID}'  `
                        }
                    );
                    if (response.status == 200) {

                        GetVehicleDeliveryScheduling();
                        setLoding(false);
                    } else {
                        setLoding(false);
                    }
                } catch (err) {
                    console.log("isDataSentBefore catch", err);
                    setLoding(false);

                }
            } else {
                setLoding(false);
            }
        }
    };
    return (
        <>


            {
                (VINDetails && brand) ?

                    <div className={"protection-and-shading   " + (brand == 1 ? " toyota-theme " : " lexus-theme ")} >

                        <div className="protection-and-shading-head" >
                            <div className="protection-and-shading-head-Logo">

                                {
                                    lang == "ar" ?

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>


                                        :

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>
                                }
                            </div>

                            <div className="protection-and-shading-head-extra flex flex-worp">
                                <div className="protection-and-shading-head-brand flex flex-worp">
                                    {
                                        (brand == 1) ?
                                            <>
                                                <img src={`/assets/icons/brands/${"toyota-logo-withName.png"}`}
                                                    className="" alt={brand} />
                                            </>
                                            :
                                            (
                                                (brand == 2) ?
                                                    <>
                                                        <img src={`/assets/icons/brands/${"lexus-logo-withName.png"}`}
                                                            className="" alt={brand} />
                                                    </>
                                                    :
                                                    null

                                            )

                                    }
                                </div>

                                <button
                                    onClick={() => {

                                        if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                                            if (window.location.href.includes("/en"))
                                                window.location = window.location.href.replace("/en", "/ar")
                                            if (window.location.href.includes("/ar"))
                                                window.location = window.location.href.replace("/ar", "/en");

                                        } else {

                                            window.location = window.location.origin + "/en" + window.location.pathname + window.location.search;
                                        }
                                    }}
                                    className="protection-and-shading-top-lang h-full  flex justify-center items-center">

                                    <span className='text-white font-bold pl-2 pr-2 capitalize'>{trans('common:changeLangCode')}</span>
                                    <img src="/assets/icons/globle.svg" alt="change language" />
                                </button>
                            </div>


                        </div >




                        <div className="protection-and-shading-titel nice-container nice-relative">
                            <div className=" p-4">
                                <div className="mainteance-popup-container-header py-5 flex flex-col ">
                                    <h3 className="text-balck text-bold text-40 my-5 ">
                                        {"مرحبًا بك،"}</h3>
                                    <p className="protection-and-shading-titel-sub1 text-24 text-bold  text-gray ">{trans("info:Congratulations_on_your_new_car")}
                                        <span className=" text-24 text-bold "> {((lang == "ar" ? VINDetails.CustNameAr : VINDetails.CustNameEn)?.split(' ')[0] ? (lang == "ar" ? " يا" : ",") + (lang == "ar" ? VINDetails.CustNameAr : VINDetails.CustNameEn).split(' ')[0] : " ")}</span> </p>
                                    <p className="protection-and-shading-titel-sub2 text-24 text-bold ">{(lang == "ar" ? "نرجو منك التحديد من الأوقات المتاحة لإستلام مركبتكم الجديدة، وذلك لضمان تجربة تسليم سلسة دون أي تأخير"
                                        : "We are pleased to inform you that your car is ready! Please select the most convenient time for you to pick it up, in order to facilitate the handover process and avoid any delays"
                                    )}</p>
                                    <p className="protection-and-shading-titel-sub2 text-24 text-bold ">{(lang == "ar" ? "نتمنى لك يومًا جميلاً!"
                                        : " We wish you a wonderful day!"
                                    )}</p>
                                    <div className='nice-flex-row my-5'>
                                        <div className='text-12 text-sub-color'>
                                            {trans("vehicales:veh-struc")} : {sn}
                                        </div>
                                    </div>


                                </div>

                            </div >

                        </div >



                        <div className="flex nice-container flex-row grid-2-cols nice-gap-2rem ">


                            <div className="grow mb-5">
                                <div className="basis-2/4 grow">

                                    <DatePicker
                                        // showIcon
                                        isClearable={!!requestForm.date}

                                        className=" w-100"
                                        selected={requestForm.date ?? null}
                                        onChange={async (value) => {


                                            const val = { ...requestForm };
                                            val.date = value;
                                            val.time = null;
                                            setRequestForm(val);
                                            setListTimeAvailable([]);

                                            if (val.date) {
                                                await GetAvailableVehicleDeliveryScheduling(moment(value).format('yyyy-MM-DD'));
                                            }
                                        }}
                                        filterDate={(date) => {
                                            const today = new Date();
                                            const yesterday = new Date(today);
                                            yesterday.setDate(today.getDate() - 1);

                                            const maxDate = new Date(today);
                                            maxDate.setDate(today.getDate() + 5); // بعد 5 أيام فقط

                                            const day = date.getDay();
                                            const IsFridayHoliday = VehicleDeliveryScheduling?.IsFridayHoliday == true ? 1 : 5;

                                            return (
                                                (day === 0 || day === 1 || day === 2 || day === 3 || day === 4 || day === 6 || day === IsFridayHoliday) &&
                                                date.setHours(0, 0, 0, 0) > yesterday.setHours(0, 0, 0, 0) &&
                                                date.setHours(0, 0, 0, 0) <= maxDate.setHours(0, 0, 0, 0)
                                            );
                                        }}

                                        placeholderText={trans("new:date")}
                                        dateFormat="yyyy-MM-dd"
                                        customInput={<DateInput3
                                            errorLabel={error?.date}
                                            value={moment(requestForm.date).format('yyyy-MM-DD')}
                                        />}
                                    />
                                </div>
                            </div>

                            <div className="grow">
                                <div className="basis-2/4 grow">
                                    <DatePicker

                                        // excludeTimes={
                                        //     listTimeAvailable.slice(0,2).map((val, index) => {
                                        //         const [hours, minutes] = val.split(':').map(Number);
                                        //         const baseDate = requestForm.date ? new Date(requestForm.date) : new Date();
                                        //         const time = new Date(baseDate);
                                        //         time.setHours(hours, minutes, 0, 0);
                                        //         return time;
                                        //     })
                                        // }
                                        // filterTime={(time) => {
                                        //     // Define your custom logic to disable specific times
                                        //     // For example, disable times before 9:00 AM and after 5:00 PM
                                        //     // const startTime = new Date().setHours(8, 0, 0); // 9:00 AM
                                        //     // const endTime = new Date().setHours(18, 0, 0); // 5:00 PM
                                        //     return !(listTimeAvailableScheduling?.find(x => x.FromTime?.includes(time))?.length > 0);
                                        // }}

                                        includeTimes={
                                            listTimeAllScheduling
                                                .map((val) => {
                                                    const [hours, minutes] = val?.FromTime?.split(':').map(Number);
                                                    const baseDate = requestForm.date ? new Date(requestForm.date) : new Date();
                                                    const time = new Date(baseDate);
                                                    time.setHours(hours, minutes, 0, 0);
                                                    return time;
                                                })
                                                .filter((time) => {
                                                    const now = new Date();
                                                    // إذا التاريخ المختار هو اليوم، استبعد الأوقات الماضية
                                                    if (
                                                        requestForm.date &&
                                                        new Date(requestForm.date).toDateString() === now.toDateString()
                                                    ) {
                                                        return time > now;
                                                    }
                                                    return true; // في الأيام القادمة، اعرض جميع الأوقات
                                                })
                                        }

                                        timeClassName={(time) => {
                                            const tm = moment(time).format('HH:mm:ss');
                                            return (!listTimeAvailableScheduling?.find(x => x.FromTime?.includes(tm))) ? "text-gray" : undefined;

                                        }}
                                        isClearable={!!requestForm.time}
                                        selected={requestForm.time ?? null}
                                        onChange={(value) => {

                                            const tm = moment(value).format('HH:mm:ss');
                                            if (listTimeAvailableScheduling?.find(x => x.FromTime?.includes(tm))) {
                                                const val = { ...requestForm };
                                                val.time = value;
                                                setRequestForm(val);
                                            }

                                        }}
                                        className="w-100"

                                        placeholderText={trans("new:time")}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={10}
                                        timeInputLabel={trans("new:time")}
                                        timeCaption={trans("new:time")}
                                        // withPortal
                                        dateFormat="hh:mm aa"
                                        // showTimeInput
                                        customInput={<DateInput3
                                            //  value={requestForm.time} 
                                            errorLabel={error?.time}
                                            extraClasses={"language-en-d  " + (lang == "ar" ? "language-ar-t" : "language-en-t")}
                                        />}

                                    // customTimeInput={<DateInput3 />}
                                    />
                                </div>
                            </div>


                            <div className="nice-row py-10 px-5 nice-flex-center ">
                                <div className="nice-col-md-6 mb-5">
                                    <div className="nice-bg-btn bg-primary text-white text-24" onClick={() => {

                                        submitRequest();

                                    }}>
                                        {trans("employment:Confirm_appointment")}

                                        {
                                            loding && <span className='mx-2 loading-btn '>
                                                <img src='/assets/icons/loading.svg' width='25' height='25' alt="" />
                                            </span>
                                        }

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div >
                    :
                    <>
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"20rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"80%"} height={"5rem"}
                            containerClassName={"flex flex-col"} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"30%"} height={"10rem"}
                            containerClassName={" flex justify-center items-center"} className={"my-5"}
                            inline={false} />
                        <Skeleton count={4} borderRadius={"2rem"} width={"100%"} height={"5rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={2} borderRadius={"2rem"} width={"100%"} height={"40rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"10rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                    </>

            }

            <Popup show={showFinalPopup}>
                <div className="w-full h-full flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {

                                VehicleDeliveryScheduling?.IsDelivered == true ?
                                    <>
                                        <div className="flex flex-row justify-center mb-10">
                                            <span className="text-20 font-bold  mx-2"> {trans("new:link_has_expired")}</span>
                                        </div>

                                    </>

                                    :
                                    <>
                                        <div className="flex flex-row justify-center mb-10">
                                            <span className="text-20 font-bold  mx-2"> {trans("new:The_appointment_has_been_booked")}</span>
                                        </div>




                                        <div className="flex flex-row justify-center">
                                            {/* <span className="text-20 font-bold  mx-2">{trans("new:date")}: </span> */}
                                            <span className="text-30 font-bold text-primary  mx-2"> {VehicleDeliveryScheduling?.BookingFrom ?
                                                moment(VehicleDeliveryScheduling.BookingFrom).locale('en').format('YYYY-MM-DD hh:mm')
                                                + ' ' + moment(VehicleDeliveryScheduling.BookingFrom).locale(lang).format('A')
                                                : null} </span>
                                        </div>



                                    </>

                            }
                            <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-16" onClick={() => {

                                        setShowFinalPopup(false);
                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                    {
                        VehicleDeliveryScheduling?.IsDelivered != true &&
                        <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                            <div className=" mb-5 w-100">
                                <div className="nice-sm-btn cart-notification-go  text-white text-16 gap-1" onClick={() => {




                                    setShowFinalPopup(false);
                                    const val = { ...requestForm };
                                    val.date = '';
                                    val.time = '';
                                    setRequestForm(val);

                                }}>


                                    {/* <img src="/assets/icons/edit.svg" width={20} height={20} alt=""></img> */}
                                    <svg
                                        id="SvgjsSvg1001"
                                        width="15"
                                        height="15"
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        xmlnsSvgjs="http://svgjs.com/svgjs"
                                    >
                                        <defs id="SvgjsDefs1002"></defs>
                                        <g id="SvgjsG1008" transform="matrix(1,0,0,1,0,0)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15" height="15">
                                                <path
                                                    d="M18.293 31.707h6.414l24-24-6.414-6.414-24 24v6.414zm27.586-24l-3.586 3.586-3.586-3.586 3.586-3.586 3.586 3.586zM20.293 26.121l17-17 3.586 3.586-17 17h-3.586v-3.586z"
                                                    fill="#ffffff"
                                                    className="color000 svgShape"

                                                ></path>
                                                <path
                                                    d="M45.293 19.707h-2v27h-38v-40h28v-5h-38v50h60z"
                                                    fill="#ffffff"
                                                    className="color000 svgShape"
                                                ></path>
                                            </svg>
                                        </g>
                                    </svg>
                                    {trans("info:edit") + " " + trans("info:the_appointment")}

                                </div>
                            </div>
                        </div>

                    }
                </div>
            </Popup>
        </>

    );
}